import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {MixAndMatchScheduleSearchModel} from "../mix-and-match-schedule-search.model";
import {MixAndMatchScheduleEntityModel} from "../mix-and-match-schedule-entity.model";
import {EditParams} from "../../../framework/entity/edit/edit-page/edit-params";

@Component({
    selector: "wbo-mix-and-match-schedule-search-page",
    templateUrl: "./mix-and-match-schedule-search-page.component.html",
    providers: [provideSearchModel(MixAndMatchScheduleSearchModel), provideEntityModel(MixAndMatchScheduleEntityModel)]
})
export class MixAndMatchScheduleSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }

    getMixAndMatchEditParams(dataItem: any): EditParams {
        return new EditParams(dataItem["mixAndMatchId"]);
    }
}
